import { Card, Grid, Typography } from "@mui/material";
import { SemestersChoices } from "utils/choices";
import { ArrayInput, BooleanInput, NumberInput, SimpleFormIterator, TextInput } from "react-admin";
import { settings } from "app";

const EditForm = ({ semesters, disciplineId }) => {
  if (!disciplineId || !semesters) return null;

  return (
    <>
      {disciplineId &&
        semesters &&
        semesters.map(semesterId => {
          const semesterName = SemestersChoices.find(c => c.id === semesterId)?.name || `Семестър ${semesterId}`;
          return (
            <Card
              key={semesterId}
              sx={{ px: 3, pt: 2, width: "100%", mb: 2 }}
            >
              <Typography
                color="primary"
                sx={{ mb: 1 }}
              >
                {semesterName}
              </Typography>
              <ArrayInput
                source={`topic_semester_${semesterId}`}
                label="Теми"
              >
                <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      md={5}
                    >
                      <TextInput
                        source="topicNameBg"
                        label="Име на български"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={5}
                    >
                      <TextInput
                        source="topicNameEn"
                        label="Име на английски"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <NumberInput
                        source="weekNumber"
                        label="Седмица номер"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <BooleanInput
                        source="isColloquium"
                        label="Колоквиум"
                      />
                    </Grid>
                  </Grid>
                </SimpleFormIterator>
              </ArrayInput>
            </Card>
          );
        })}
    </>
  );
};

export default EditForm;
